import { BatchFlightUpload } from "@/components/admin/BatchFlightUpload";
import { Upload } from "lucide-react";

const UploadCsvPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Upload className="h-8 w-8" />
          Upload CSV Flight Schedule
        </h1>
        <p className="text-muted-foreground mt-2">
          Upload CSV file with flight data for batch import
        </p>
      </div>

      <BatchFlightUpload />
    </div>
  );
};

export default UploadCsvPage;
